import { DefaultComparator } from './comparators/default-comparator';
import {
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions,
  GridFilterUnionModel,
  InclusiveExclusiveFilterModel,
  RadioFilterModel,
  FilterPassParams,
  AdvancedFilterName
} from '../filter-types';
import { convertToStringArray } from '../filter-utils';
import { SeriesFilterHandler } from './base/series-filter-handler';
import { CalendarFilter } from '../../../state/calendar-filter/state';
import { RadioOption } from '../../../grid/types/option.types';
import { FilterType } from '../../../grid/utils/filter/filter.utils';
import { FilterResultFacade } from '../filter-result-facade';
import { IsQIB } from '../../../types/deal.types';

export class QIBFilterHandler extends SeriesFilterHandler {
  private comparator: IFilterComparator<any>;

  get name(): string {
    return AdvancedFilterName.qib;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.qib = params.filterOptions.qib;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.qib);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    let gridValue, storeValue;
    if ((grid && !store) || (!grid && store)) {
      gridValue = grid;
      storeValue = store;
    } else if (grid && store) {
      gridValue = grid.values;
      storeValue = store.values;
    }

    return this.getValidDiffComparator(options).hasValidDiff(
      gridValue,
      storeValue
    );
  }

  getValidDiffComparator(options): IFilterComparator<any> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  toStoreFilterModel(
    model: GridFilterUnionModel,
    filterOptions: FilterOptions
  ): GridFilterUnionModel {
    let resultModel: RadioFilterModel;
    if (model) {
      const originalModel: Partial<InclusiveExclusiveFilterModel> = model as Partial<InclusiveExclusiveFilterModel>;
      if (Object.prototype.hasOwnProperty.call('values', originalModel)) {
        resultModel = {
          checked: true,
          value: originalModel.values[0],
          label: originalModel.values[0],
          filterType: FilterType.Radio,
          settings: undefined
        };
      }
    }
    return resultModel || model;
  }

  toGridFilterModel(
    filter: CalendarFilter,
    filterOptions: FilterOptions
  ): GridFilterUnionModel {
    const model: RadioOption = filter.model as RadioOption;
    return Object.prototype.hasOwnProperty.call('value', model)
      ? {
          filterType: FilterType.Set,
          values: [model.value]
        }
      : filter.model;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let qibFilterPassed = true;
    const qib = params.filters[this.name];
    qibFilterPassed = qib
      ? params.deal.series.some(
          (key) => !!IsQIB[qib.model.value] === !!key.isQIB
        )
      : true;
    result.applyDealFilerResult(params.deal.id, this.name, qibFilterPassed);

    return qibFilterPassed;
  }
}
